package kz.dentalcrm.app.data.network.request_model

import kotlinx.serialization.Serializable

@Serializable
data class Category(
    val created_at: String,
    val id: Int,
    val name: String,
    val organization_id: Int,
    val updated_at: String
)